// extracted by mini-css-extract-plugin
module.exports = {"headerOverlay":"style_headerOverlay__1D9EG","siteHeader":"style_siteHeader__371tk","siteTitle":"style_siteTitle__OltA-","siteTitleInner":"style_siteTitleInner__276BX"};